import {
  Box,
  Button,
  createStyles,
  Dialog,
  FormControl,
  FormControlLabel,
  makeStyles,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import { useState } from 'react'
import { ExperienceType } from '../types/vmdata'
import { useDispatch, useSelector } from 'react-redux'
import { setExperienceType } from '../features/experienceType/experienceTypeSlice'
import { Experience } from '../types/expType'

interface Props {
  isOpen: boolean
  onDialogClose: () => void
  onSelect: () => void
}

const useStyles = makeStyles(() =>
  createStyles({
    dialogContent: {
      padding: '3rem',
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '2rem',
    },
    radioLabel: {
      '& .MuiFormControlLabel-label': {
        fontSize: '1.35rem',
      },
    },
    btnText: {
      fontSize: '1.35rem',
    },
    btnsWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  })
)

export const SelectConfigurationDialog: React.FC<Props> = ({
  isOpen,
  onSelect,
  onDialogClose,
}) => {
  const styles = useStyles()
  const expType = useSelector((state) => state.vmData.expType)
  const [value, setValue] = useState(expType as ExperienceType)

  const dispatch = useDispatch()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value as ExperienceType)
  }

  const handleSelect = () => {
    dispatch(setExperienceType(value))
    onSelect()
  }

  return (
    <Dialog open={isOpen} onClose={onDialogClose}>
      <Box className={styles.dialogContent}>
        <Typography className={styles.title}>
          Please select the experience type to be used for configuration.
        </Typography>
        <FormControl component="fieldset">
          <RadioGroup value={value} onChange={handleChange}>
            <FormControlLabel
              className={styles.radioLabel}
              value={Experience.VMGEN}
              control={<Radio color="primary" />}
              label="VMGEN"
            />
            <FormControlLabel
              className={styles.radioLabel}
              value={Experience.DigitalWindow}
              control={<Radio color="primary" />}
              label="Digital Window"
            />
          </RadioGroup>
        </FormControl>
        <Box className={styles.btnsWrapper}>
          <Button onClick={onDialogClose} style={{ marginRight: '2rem' }}>
            <Typography className={styles.btnText}>cancel</Typography>
          </Button>
          <Button color="primary" variant="contained" onClick={handleSelect}>
            <Typography className={styles.btnText}>select</Typography>
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}
